import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStrategy = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 19 18",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.418 0a7.054 7.054 0 104.445 12.531l5.255 5.255a.73.73 0 101.032-1.032L12.895 11.5A7.054 7.054 0 007.418 0zm0 1.46a5.595 5.595 0 110 11.189 5.595 5.595 0 010-11.19z",
		fillRule: "evenodd"
	})
});
export default SvgStrategy;
